import BusinessCategoryAddForm from './BusinessCategoryAddForm';

export default BusinessCategoryAddForm;
